
/**
 * Emit events from scripting using the runtime event queue.
 *
 * This is a curried utility function. It returns an emitter function that,
 * when called with a sender and data, will enqueue an event into the runtime.
 * 
 */
const emit = (runtime) => (sender, data) => { runtime.enqueueEvent(sender, data) };

export { emit };